import {Component} from 'react';
import {FormError} from './form-errors';
import {RadioBox} from './radiobox';
import {MontantInput} from './montant-input';
import {DisplayBox} from './displaybox';
import InfoBulle from './info';
import ReductionEligibility from './reduction-eligibility';
import MeetingSelector from './meeting-selector';
import analytics, { CONDITIONAL_IDS, FIELD_IDS } from '../../services/analytics';

const STEP_NUMBER = 4;

class Logement extends Component {

	constructor (props) {
		super(props);

		// Récupérer le field tracker pour le tracking granulaire des champs
		this.fieldTracker = analytics.getFieldTracker();

		this.state = {
			optionsVille :[],
			validations: {
				codePostal :[]
			},
			ville:0,
			situationLogement:null,
			codePostal : this.props.codePostal ? this.props.codePostal : null,
			codeInsee : null,
			codeEpci : null,
			regionCode : null,
			nomVille : null,
			siren : null,
			validationErrors : [],
			payeFraisLogement : null , //menage participation_frais
			primoAccedant : null,
			typeLocation : null,
			isColoc :null,
			proprietaireProcheFamille:null,
			isChambre :null,
			loyer:'',
			mensualites :'',
			chargeLocative:'',
			// Questions moved from avant-de-terminer.js
			difficulte: null,
			achatLogement: null,
			travaux: null,
			changementLogementRecent: null,
			// Reduction eligibility
			reductionEligibility: null,
			reductionEligibilityData: null,
			selectedMeeting: null, // Store selected meeting time
			// Step system for additional questions
			additionalQuestionStep: 0, // 0 = not started, 1-4 = questions, 5 = reduction eligibility, 6 = meeting selection
			// Track where we came from when showing reduction eligibility
			cameFromStep: null,
			// Track validation errors for additional questions
			validationErrorsAdditional: {
				changementLogementRecent: false,
				difficulte: false,
				travaux: false,
				achatLogement: false,
				reductionEligibility: false,
			},
			optionsTypeLocation : {
				'Non Meublé':'nonmeuble',
				'Meublé': 'meublehotel',
				'Foyer' : 'foyer',
				'Résidence universitaire ' : 'universitaire',
				'EHPAD' : 'ehpad',
				'Logement social' : 'hlm',
			}

		};

	this.statusOccupationMap = {
      proprietaireprimoaccedant: 'primo_accedant',
      proprietaire: 'proprietaire',
      locatairenonmeuble: 'locataire_vide',
      locatairemeublehotel: 'locataire_meuble',
      heberge: 'loge_gratuitement',
      locatairefoyer: 'locataire_foyer',
      sansDomicile : 'sans_domicile',
      locataireuniversitaire : 'locataire_foyer',
      locataireehpad: 'locataire_foyer' ,
      locatairehlm : 'locataire_foyer',
    };

    this.erreurValidationMap = {
      payeFraisLogement : "Veuillez indiquer si vous participez aux frais de logement" ,
			primoAccedant : "Veuillez indiquer si vous êtes primo-accédant",
			typeLocation : "Veuillez renseigner le type de logement",
			isColoc :"Veuillez renseigner si vous êtes en colocation",
			proprietaireProcheFamille:"Veuillez renseigner si vous avez un lien de parenté avec votre propriétaire",
			isChambre :"Veuillez indiquer si votre logement est une chambre",
			loyer:"Veuillez indiquer votre loyer",
			chargeLocative:"Veuillez indiquer le montant de vos charges",
//			codeInsee:"Veuillez choisir une ville / commune avant de passer à l'étape suivante",
			situationLogement : "Veuillez renseigner votre situation de logement",
			codePostal : "Veuillez saisir un code postal valide.",
    };

		this.state.optionsSituationLogement = [
			{
              label: 'Locataire',
              value: 'locataire'
            },
            {
              label: 'Propriétaire',
              value: 'proprietaire'
            },
            {
              label: 'Hébergé (chez vos parents, chez un tiers...)',
              value: 'heberger'
            },
            {
              label: 'Sans domicile stable',
              value: 'sans_domicile'
            }
		];

		if (this.props.codePostal && this.props.ville){
				this.getCitiesFromPostalCode(this.props.codePostal , this.props.ville);
		}

	}

	// Mapping champ → code erreur pour le tracking analytics
	fieldToErrorCode = {
		situationLogement: 'HOUSING_STATUS_REQUIRED',
		codePostal: 'POSTAL_CODE_REQUIRED',
		codeInsee: 'CITY_REQUIRED',
		loyer: 'RENT_REQUIRED',
		chargeLocative: 'CHARGES_REQUIRED',
		typeLocation: 'RENTAL_TYPE_REQUIRED',
		isColoc: 'COLOCATION_REQUIRED',
		primoAccedant: 'FIRST_TIME_BUYER_REQUIRED',
		payeFraisLogement: 'HOSTED_FEES_REQUIRED',
		proprietaireProcheFamille: 'LANDLORD_RELATION_REQUIRED',
		isChambre: 'IS_ROOM_REQUIRED'
	};

	checkRequiredDatas = ( requiredDatas) => {
		return requiredDatas.reduce( ( stillValid , dataName) => {
					if ( [undefined  , null , NaN , ""].includes(this.state[dataName]) ) {
						stillValid = false;
						this.setState( ({validationErrors})=>{

							const newErrors  = [ ...validationErrors, this.erreurValidationMap[dataName]];
							return {validationErrors : newErrors};
						});
						// Tracker l'erreur de validation
						const errorCode = this.fieldToErrorCode[dataName];
						if (errorCode) {
							analytics.trackValidationError(STEP_NUMBER, errorCode, dataName);
						}
					}
					return stillValid;
				} , true);
	}

	validateLogement  = async () =>{
		console.log('validateLogement called');
		var data = {
			menage : {},
			famille : {},
		};
		// Reset validation errors state 
		this.setState( ()=>({
			validationErrors : []
		}));

		var dataValid = this.checkRequiredDatas(["situationLogement"]);
		console.log('situationLogement validation:', dataValid, 'value:', this.state.situationLogement);
		// validate data and assign variables to openfisca entity 
		if (dataValid){
			if ( this.state.situationLogement === "locataire") {
				const requiredDatas = ["isColoc" , "typeLocation" , "proprietaireProcheFamille" , "loyer" ];
				dataValid =this.checkRequiredDatas(requiredDatas);
				console.log('locataire validation:', dataValid, 'values:', {
					isColoc: this.state.isColoc,
					typeLocation: this.state.typeLocation,
					proprietaireProcheFamille: this.state.proprietaireProcheFamille,
					loyer: this.state.loyer
				});

				if (dataValid) {
					data.menage.coloc = JSON.parse(this.state.isColoc);
					data.famille.proprietaire_proche_famille = JSON.parse(this.state.proprietaireProcheFamille);

					/* Status occupation logement*/
					const userStatus = this.state.situationLogement+this.state.typeLocation;
					
					data.menage.statut_occupation_logement = this.statusOccupationMap[userStatus];

					/* Loyer */
					data.menage.loyer = this.state.loyer < 0 ? 0 : this.state.loyer;

					if ( this.state.typeLocation !== "meublehotel") {
						dataValid = this.checkRequiredDatas(['chargeLocative']);
						
						if (dataValid) data.menage.charges_locatives = this.state.chargeLocative < 0 ? 0 : this.state.chargeLocative ;
					}

					if (['nonmeuble', 'meubleholte'].includes(this.state.typeLocation) && dataValid) {
						dataValid = this.checkRequiredDatas(["isChambre"]);
						
						if (dataValid) data.menage.logement_chambre = JSON.parse(this.state.isChambre);
					}else{
						data.menage.logement_chambre = false;
					}
					
				}


			} else if ( this.state.situationLogement === "proprietaire") {
				const requiredDatas = ["primoAccedant" ];
				dataValid =this.checkRequiredDatas(requiredDatas);				
				if (dataValid){
					const userStatus = this.state.situationLogement+ ( JSON.parse(this.state.primoAccedant)  ? 'primoaccedant' : '');
					data.menage.statut_occupation_logement = this.statusOccupationMap[userStatus];
					data.menage.charges_locatives =  ![undefined  , null , NaN , ""].includes(this.state.mensualites) ? this.state.mensualites : 0;
				}
			} else if ( this.state.situationLogement === "heberger") {
				dataValid = this.checkRequiredDatas( ["payeFraisLogement"] );
				//console.log('heberger validation:', dataValid, 'value:', this.state.payeFraisLogement);

				if (dataValid) {
					data.menage.statut_occupation_logement = "loge_gratuitement";
					data.menage.participation_frais = JSON.parse(this.state.payeFraisLogement);
				}
			} else if ( this.state.situationLogement === "sans_domicile"){
				data.menage.statut_occupation_logement = "sans_domicile";
			} else {
				data.menage.statut_occupation_logement = "non_renseigne";
			}
		}

		if (dataValid) {
			dataValid = this.checkRequiredDatas( ["codePostal" , "codeInsee"]);
			console.log('codePostal/codeInsee validation:', dataValid, 'values:', {
				codePostal: this.state.codePostal,
				codeInsee: this.state.codeInsee
			});
		}

		if (dataValid) {
			
			data.menage.depcom = this.state.codeInsee ;
			data.menage.code_postal = this.state.codePostal;
			data.menage.codeEpci = this.state.codeEpci;
			data.menage.nomVille = this.state.nomVille;
			data.menage.regionCode = this.state.regionCode;
			data.menage.siren = this.state.siren;
			
			// Add moved questions data
			data.demandeur = {
				difficultes : this.state.difficulte,
				//travaux
				travaux : this.state.travaux,
				//achat_logement
				achatlogement : this.state.achatLogement,
				// changement logement recent
				changementLogementRecent : this.state.changementLogementRecent,
			};
			
			// Add reduction eligibility data to menage object if available
			if (this.state.reductionEligibilityData) {
				data.menage.reductionEligibilityData = this.state.reductionEligibilityData;

			}

			// Envoyer le profil logement à Supabase pour segmentation (même en cas d'abandon)
			await analytics.updateUserProfile({
				housing_type: this.state.situationLogement,
				department: this.state.codePostal ? this.state.codePostal.substring(0, 2) : null
			});

			this.props.validateStep(data);
		} else {
			console.log('Validation failed, not calling validateStep');
			console.log('Current state:', this.state);
		}
		// If dataValid is false, the validation errors should be displayed
		// If dataValid is true but we're still here, there might be an issue with validateStep
	}

	/* Fetch data from API */
	getCitiesFromPostalCode = (code_postal , villeCodeInsee) =>{
		let urlAPI = "https://simulateurs.aide-sociale.fr/simulateur-aide-sociale/communes.php?code_postal=" + code_postal;
		this.setState(()=>({
			loadingVilles : true,
		}));


		fetch(urlAPI)
			.then((res)=> res.json())
			.then((json)=>{
				const cities = json;

				this.setState( ()=> {
					if (cities.length > 0 ){
						var index = 0 ;

						if (typeof villeCodeInsee !== 'undefined' && villeCodeInsee !== null){
							cities.forEach( (city , i) => {
								if (villeCodeInsee === city.code ) index  = i;
							});
						}
						
						const villeData = cities[index];
						const newCodeInsee = villeData.code;
						return {
							optionsVille:cities,
							ville : index,
							codeInsee:newCodeInsee,
							codeEpci : villeData.codeEpci,
							nomVille : villeData.nom,
							regionCode : villeData.codeRegion,
							siren : villeData.siren, 
							loadingVilles : false,
						};
						
					}
					return { 
						optionsVille : cities,
						loadingVilles :false
					}
				});
			});
	}
	
	/*Events Handlers*/
	handleChangeSituationLogement = (e)=> {
		const situation = e.target.value;

		// Field tracking
		this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.statut_occupation, this.state.situationLogement);
		this.fieldTracker.onFieldChange(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.statut_occupation, situation);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.statut_occupation, situation);

		// Tracker le type de logement pour la segmentation
		analytics.setUserHousingType(situation);

		// Tracker les sections conditionnelles selon le type de logement
		if (situation === 'locataire') {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.TENANT_DETAILS, 'situationLogement');
		} else if (situation === 'proprietaire') {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.OWNER_DETAILS, 'situationLogement');
		} else if (situation === 'heberger') {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.HOSTED_DETAILS, 'situationLogement');
		}

		this.setState( ()=>{
			return {situationLogement : situation };
		});
	}

	handleChangeCodePostal = (e)=>{
		const newCodePostal = e.target.value;

		// Field tracking
		this.fieldTracker.onFieldChange(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.code_postal, newCodePostal);

		if (newCodePostal.length < 6){
			let validationErrors =[];
			if (e.target.value.length >= 5){
				// appel API code postal
				this.getCitiesFromPostalCode(newCodePostal);

				// Tracker le département pour la segmentation
				analytics.setUserDepartment(newCodePostal);

				// Field completed
				this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.code_postal, newCodePostal);

			}else{
				validationErrors.push(this.erreurValidationMap.codePostal);
			}

			this.setState(({validations})=>{
				validations.codePostal = validationErrors;
				return {
					validations : validations,
					codePostal : newCodePostal
				};
			});
		}
	}

	handleChangeVille = (e)=> {
		const villeData = this.state.optionsVille[e.target.value];
		const newCodeInsee = villeData.code;

		// Field tracking
		this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.ville, this.state.codeInsee);
		this.fieldTracker.onFieldChange(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.ville, villeData.nom);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_HOUSING.ville, villeData.nom);

		this.setState(()=>{
			return {
				codeInsee:newCodeInsee,
				codeEpci : villeData.codeEpci,
				nomVille : villeData.nom,
				regionCode : villeData.codeRegion,
				siren : villeData.siren,
			}
		});
	}

	handleRadioSwitch = (newValue , modelName)=>{
		// Field tracking - map modelName to FIELD_IDS
		const fieldIdMap = {
			'isColoc': FIELD_IDS.STEP_HOUSING.colocation,
			'proprietaireProcheFamille': FIELD_IDS.STEP_HOUSING.proprietaire_proche,
			'typeLocation': FIELD_IDS.STEP_HOUSING.type_location,
			'isChambre': FIELD_IDS.STEP_HOUSING.is_chambre,
			'primoAccedant': FIELD_IDS.STEP_HOUSING.primo_accedant,
			'payeFraisLogement': FIELD_IDS.STEP_HOUSING.paye_frais_logement,
			'changementLogementRecent': FIELD_IDS.STEP_HOUSING.question_demenagement,
			'difficulte': FIELD_IDS.STEP_HOUSING.question_difficultes,
			'travaux': FIELD_IDS.STEP_HOUSING.question_travaux,
			'achatLogement': FIELD_IDS.STEP_HOUSING.question_achat,
		};
		const fieldId = fieldIdMap[modelName] || `FIELD_${modelName.toUpperCase()}`;

		this.fieldTracker.onFieldFocus(STEP_NUMBER, fieldId, this.state[modelName]);
		this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, newValue);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, fieldId, newValue);

		// Track colocation conditional if isColoc is true
		if (modelName === 'isColoc' && (newValue === true || newValue === "true")) {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.COLOCATION_DETAILS, 'isColoc');
		}

		this.setState( (prevState) => {
			var newState = {};
			// Convert string "true"/"false" to boolean values
			if (newValue === "true") {
				newState[modelName] = true;
			} else if (newValue === "false") {
				newState[modelName] = false;
			} else {
				newState[modelName] = newValue;
			}

			// Clear the validation error for this model when a selection is made
			if (modelName in prevState.validationErrorsAdditional) {
				const newValidationErrors = { ...prevState.validationErrorsAdditional };
				newValidationErrors[modelName] = false;
				newState.validationErrorsAdditional = newValidationErrors;
			}

			return newState;
		});
	}

	handleMontantChange = (newValue , modelName)=>{
			// Field tracking - map modelName to FIELD_IDS
			const fieldIdMap = {
				'loyer': FIELD_IDS.STEP_HOUSING.loyer,
				'chargeLocative': FIELD_IDS.STEP_HOUSING.charges,
				'mensualites': FIELD_IDS.STEP_HOUSING.mensualites,
			};
			const fieldId = fieldIdMap[modelName] || `FIELD_${modelName.toUpperCase()}`;
			this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, newValue);

			this.setState( ()=>{
				var newState = {};
				newState[modelName] = newValue;
				return newState;
			});
	}
	
	handleReductionEligibilityChange = (newValue) => {
		this.setState({
			reductionEligibility: newValue
		});
	}
	
	handleReductionEligibilityData = (data) => {
		this.setState({
			reductionEligibilityData: data
		});
	}
	
	handleMeetingSelection = (meetingTime) => {
		this.setState({
			selectedMeeting: meetingTime
		}, () => {
			// Update the reductionEligibilityData with the meeting info if it exists
			if (this.state.reductionEligibilityData) {
				const updatedData = {
					...this.state.reductionEligibilityData,
					meeting: meetingTime
				};
				this.setState({
					reductionEligibilityData: updatedData
				});
			}
		});
	}
	
	/* Question methods for moved questions */
	difficulte =()=>{
		return <div className="question">
			<RadioBox 
				name="difficulte"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.difficulte}
				handler={this.handleRadioSwitch}
				modelName="difficulte"
			><h3>Avez-vous des difficultés financières pour payer les factures courantes ou les besoins de première nécessité ?</h3></RadioBox>
		</div>;
	}
	
	achatLogement =()=>{
		return <div className="question">
			<RadioBox 
				name="achatLogement"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.achatLogement}
				handler={this.handleRadioSwitch}
				modelName="achatLogement"
			><h3>Souhaitez vous connaitre les aides liées à l'achat d'un logement ?</h3></RadioBox>
		</div>;
	}
	
	travaux =()=>{
		return <div className="question">
			<RadioBox 
				name="travaux"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.travaux}
				handler={this.handleRadioSwitch}
				modelName="travaux"
			><h3>Envisagez-vous de faire des travaux dans votre logement ?</h3></RadioBox>
		</div>;
	}
	
	changementLogementRecent =()=>{
		return <div className="question">
			<RadioBox 
				name="changementLogementRecent"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.changementLogementRecent}
				handler={this.handleRadioSwitch}
				modelName="changementLogementRecent"
			><h3>Envisagez-vous de déménager prochainement ?</h3></RadioBox>
		</div>;
	}
	
	// Navigation methods for additional questions
	startAdditionalQuestions = () => {
		this.setState({ additionalQuestionStep: 1 });
	}
	
	nextAdditionalQuestion = () => {
		const { additionalQuestionStep, validationErrorsAdditional } = this.state;
		
		// Check if user has made a selection before proceeding and set validation errors
		let hasValidationErrors = false;
		let newValidationErrors = { ...validationErrorsAdditional };
		
		if (additionalQuestionStep === 1 && this.state.changementLogementRecent === null) {
			// Set validation error flag for question 1
			newValidationErrors.changementLogementRecent = true;
			hasValidationErrors = true;
		} else if (additionalQuestionStep === 2 && this.state.difficulte === null) {
			// Set validation error flag for question 2
			newValidationErrors.difficulte = true;
			hasValidationErrors = true;
		} else if (additionalQuestionStep === 3 && this.state.travaux === null) {
			// Set validation error flag for question 3
			newValidationErrors.travaux = true;
			hasValidationErrors = true;
		} else if (additionalQuestionStep === 4 && this.state.achatLogement === null) {
			// Set validation error flag for question 4
			newValidationErrors.achatLogement = true;
			hasValidationErrors = true;
		}
		
		// If there are validation errors, update the state to show them and return early
		if (hasValidationErrors) {
			this.setState({ validationErrorsAdditional: newValidationErrors });
			return;
		}
		
		// Clear validation errors for the current step before proceeding
		if (additionalQuestionStep === 1) {
			newValidationErrors.changementLogementRecent = false;
		} else if (additionalQuestionStep === 2) {
			newValidationErrors.difficulte = false;
		} else if (additionalQuestionStep === 3) {
			newValidationErrors.travaux = false;
		} else if (additionalQuestionStep === 4) {
			newValidationErrors.achatLogement = false;
		}
		
		// Update the state to clear validation errors
		this.setState({ validationErrorsAdditional: newValidationErrors });
		
		// Handle each question step explicitly
		if (additionalQuestionStep === 1) {
		
			this.handleQuestion1();
		} else if (additionalQuestionStep === 2) {
			// Question 2: difficulte
			// Check if we should show reduction eligibility
			const { difficulte, reductionEligibilityData, isColoc, situationLogement, typeLocation } = this.state;
			const isDifficulte = difficulte === true || difficulte === "true";
			const hasShownReductionEligibility = reductionEligibilityData !== null;
			const isUserInColoc = isColoc === true || isColoc === "true";
			const isValidSituation = situationLogement !== 'heberger' && situationLogement !== 'sans_domicile';
			const isInvalidTypeLocation = situationLogement === 'locataire' && 
				(typeLocation === 'foyer' || typeLocation === 'ehpad' || typeLocation === 'universitaire');
			
			// Show reduction eligibility if user answered "oui" to difficulte and we haven't shown it yet
			// But only if the user is not in colocation, has a valid situation, and doesn't have invalid typeLocation
			if ( !hasShownReductionEligibility && !isUserInColoc && isValidSituation && !isInvalidTypeLocation) {
				this.setState({ additionalQuestionStep: 5, cameFromStep: 2 }); // Show reduction eligibility, came from step 2
			} else {
				// Move to question 3
				
				this.setState({ additionalQuestionStep: 3 });
			}
		} else if (additionalQuestionStep === 3) {
			// Question 3: travaux
			// Reduction eligibility should NOT be shown for travaux
			
			this.setState({ additionalQuestionStep: 4 });
		} else if (additionalQuestionStep === 4) {
			// Question 4: achatLogement
			// We've reached the end of the questions, proceed to the next step (resources)
			
			this.validateLogement();
		}
		// Note: Step 5 (reduction eligibility) is handled separately by handleReductionEligibilityData and completeAdditionalQuestions
	}
	
	handleQuestion1 = () => {
		const { changementLogementRecent, situationLogement, isColoc, reductionEligibilityData, typeLocation, validationErrorsAdditional } = this.state;
		
		// Check if the user has made a selection before proceeding
		if (changementLogementRecent === null) {
			// Set validation error and return early
			const newValidationErrors = { ...validationErrorsAdditional, changementLogementRecent: true };
			this.setState({ validationErrorsAdditional: newValidationErrors });
			return;
		}
		
		// Clear validation error for this question since user has made a selection
		const newValidationErrors = { ...validationErrorsAdditional, changementLogementRecent: false };
		this.setState({ validationErrorsAdditional: newValidationErrors });
		
		// Convert values to boolean for comparison
		const isChangementLogementRecent = changementLogementRecent === true || changementLogementRecent === "true";
		const isColocBoolean = isColoc === true || isColoc === "true";
		
		// Show reduction eligibility if user answered "oui" to question 1 (changementLogementRecent)
		// But only if the situation allows it (not heberge or sans_domicile, and not in colocation)
		const isValidSituation = situationLogement !== 'heberger' && situationLogement !== 'sans_domicile' && !(situationLogement === 'locataire' && isColocBoolean);
		const isInvalidTypeLocation = situationLogement === 'locataire' && 
			(typeLocation === 'foyer' || typeLocation === 'ehpad' || typeLocation === 'universitaire');
		const canShowReductionEligibility = isValidSituation && !isInvalidTypeLocation;
		
		// If we've already shown reduction eligibility, we don't show it again
		const hasShownReductionEligibility = reductionEligibilityData !== null;
		
		if (isChangementLogementRecent && canShowReductionEligibility && !hasShownReductionEligibility) {
			this.setState({ additionalQuestionStep: 5, cameFromStep: 1 }); // Show reduction eligibility, came from step 1
		} else {
			// Move to question 2
			this.setState({ additionalQuestionStep: 2 });
		}
	}
	
	previousAdditionalQuestion = () => {
		if (this.state.additionalQuestionStep > 1) {
			this.setState({ additionalQuestionStep: this.state.additionalQuestionStep - 1 });
		} else {
			this.setState({ additionalQuestionStep: 0 }); // Go back to main form
		}
	}
	
	skipToNextQuestion = () => {
		const { additionalQuestionStep } = this.state;
		if (additionalQuestionStep < 4) {
			this.setState({ additionalQuestionStep: additionalQuestionStep + 1 });
		} else {
			// Automatically proceed to the next step (resources)
			this.validateLogement();
		}
	}
	
	completeAdditionalQuestions = () => {
		// Check if we're at the reduction eligibility step
		if (this.state.additionalQuestionStep === 5) {
			// First, validate the reduction eligibility selection
			if (this.reductionEligibilityRef && typeof this.reductionEligibilityRef.validateSelection === 'function') {
				const isValid = this.reductionEligibilityRef.validateSelection();
				if (!isValid) {
					// If validation fails, set validation error and don't proceed
					this.setState(prevState => ({
						validationErrorsAdditional: {
							...prevState.validationErrorsAdditional,
							reductionEligibility: true
						}
					}));
					return;
				}
			}
			
			// If validation passes, clear validation error and check if we need to show meeting selector
			this.setState(prevState => ({
				validationErrorsAdditional: {
					...prevState.validationErrorsAdditional,
					reductionEligibility: false
				}
			}), () => {
				// Check if user selected 'later' for reduction eligibility
				if (this.state.reductionEligibilityData && this.state.reductionEligibilityData.selectedOption === 'later') {
					// Go to meeting selection step (step 6)
					this.setState({ additionalQuestionStep: 6 });
				} else {
					// If user didn't select 'later', determine where to go next based on cameFromStep
					const { cameFromStep } = this.state;
					
					// If we know where we came from, go to the next step after that
					if (cameFromStep) {
						let nextStep;
						switch (cameFromStep) {
							case 1: // Came from changementLogementRecent
								nextStep = 2; // Go to difficulte
								break;
							case 2: // Came from difficulte
								nextStep = 3; // Go to travaux
								break;
							case 3: // Came from travaux
								nextStep = 4; // Go to achatLogement
								break;
							default:
								nextStep = 2; // Default to difficulte
						}
						this.setState({ additionalQuestionStep: nextStep, cameFromStep: null });
					} else {
						// If we don't know where we came from, default to difficulte
						this.setState({ additionalQuestionStep: 2, cameFromStep: null });
					}
				}
			});
		} else if (this.state.additionalQuestionStep === 6) {
			// We're at the meeting selection step, so first validate if a meeting time has been selected
			if (this.meetingSelectorRef && typeof this.meetingSelectorRef.validateSelection === 'function') {
				// Validate that a meeting time has been selected
				const isValid = this.meetingSelectorRef.validateSelection();
				if (!isValid) {
					// If validation fails, don't proceed
					return;
				}
			}
			
			// After meeting selection is validated, make sure to call validateLogement to send the complete data
			// with meeting information to the parent component
			this.validateLogement();
		} else {
			// Instead of showing an extra step, automatically proceed to the next step (resources)
			this.validateLogement();
		}
	}
	
	/* Views */
	formLocataire = ()=>{
		const infoChambre= <p>Une chambre est un logement qui ne comporte qu'une seule pièce et n'est pas équipée d'un WC.</p>;
		
		const displayQuestionChambre = (
			this.state.typeLocation === 'meublehotel' ||
			this.state.typeLocation === 'nonmeuble'
		) ? true : null ;
		
		return <>
				<RadioBox 
					name="colocation" 
					options={{"Oui":true, "Non":false}} 
					handler={this.handleRadioSwitch}
					defaultValue={this.state.isColoc}
					modelName="isColoc"
				>Est-ce une colocation ?</RadioBox>
				<DisplayBox display={this.state.isColoc}>
					<RadioBox name="proprietaire_proche_famille"
						options={{"Oui":true , "Non":false}}
						handler={this.handleRadioSwitch}
						defaultValue={this.state.proprietaireProcheFamille}
						modelName="proprietaireProcheFamille"
					>
						Avez-vous un lien de parenté direct avec votre propriétaire ?<br/>
						<small>Est-il un ascendant ou descendant de vous ou votre conjoint·e (enfant, grand-parent…) ?</small>
					</RadioBox>
				</DisplayBox>

				<DisplayBox display={this.state.proprietaireProcheFamille} >
					<RadioBox name="typeLocation"
						options={this.state.optionsTypeLocation}
						handler={this.handleRadioSwitch}
						defaultValue={this.state.typeLocation}
						modelName="typeLocation"
					>Quel type de logement louez-vous ?</RadioBox>
				</DisplayBox>
				<DisplayBox display={displayQuestionChambre}>
					<RadioBox name="chambre"
						options={{"Oui":true, "Non":false}}
						handler={this.handleRadioSwitch}
						defaultValue={this.state.isChambre}
						modelName="isChambre"
					>Est-ce une chambre ? <InfoBulle message={infoChambre}/></RadioBox>
				</DisplayBox>
				
				<DisplayBox display ={this.state.typeLocation}>
				{ ( this.state.typeLocation !== 'meublehotel') ?
					<div className="fade-in">
						<MontantInput
							name="loyer"
							model={this.state.loyer}
							modelName="loyer"
							handler={this.handleMontantChange}
						 >Votre loyer (hors charges)</MontantInput>
						
						<MontantInput
							name="charges_locative"
							model={this.state.chargeLocative}
							modelName="chargeLocative"
							handler={this.handleMontantChange}
						 >Vos charges locatives</MontantInput>
					</div>
					:  <div className="loyer-container fade-in"><MontantInput
							name="loyer"
							model={this.state.loyer}
							modelName="loyer"
							handler={this.handleMontantChange}
						 >Votre loyer (charges comprises)</MontantInput></div>
				}
				</DisplayBox>

			</>;
	}

	formProprietaire = ()=>{
		return <>
			<RadioBox name="primoAccedant"
				options={{"Oui":true, "Non":false}}
				handler={this.handleRadioSwitch}
				defaultValue={this.state.primoAccedant}
				modelName="primoAccedant"
			>
				Êtes-vous primo-accédant pour cette propriété ?<br/>
				<small>Un primo-accédant est une personne (ou un ménage) qui n’a pas été propriétaire de sa résidence principale dans les deux années qui viennent de s’écouler au moment où il achète son bien</small>
			</RadioBox>
			<div className="loyer-container">
				<MontantInput
					name="mensualites"
					model={this.state.mensualites}
					modelName="mensualites"
					handler={this.handleMontantChange}
				 >
				 	Montant des mensualités <br/>
					<small>Laissez ce champ à 0 € si vous ne remboursez pas actuellement de crédit pour votre logement.</small>
				</MontantInput>
			</div>
		</>;
	}

	formHeberge = ()=>{
		return <>
			<RadioBox 
				name="payeFraisLogement" 
				options={{"Oui":true, "Non":false}} 
				handler={this.handleRadioSwitch}
				defaultValue={this.state.payeFraisLogement}
				modelName="payeFraisLogement"
			>Participez-vous aux frais de logement ?</RadioBox>
		</>;

	}

	formulaireLogement = ()=>{
		/* Formulaire afficher selon le status d'occupation choisi par l'utilisateur */
		if ( this.state.situationLogement === "locataire") {
			return this.formLocataire();
		} else if ( this.state.situationLogement === "proprietaire") {
			return this.formProprietaire();
		} else if ( this.state.situationLogement === "heberger") {
			return this.formHeberge();
		} else if ( this.state.situationLogement === "sans_domicile") {
			return <></>;
		}
	}

	previous = () => {
		this.props.previousStep();
	}

	restart = ()=> {
		this.props.restart();
	}
	
	// Update restart method to reset additional questions step
	previous = () => {
		if (this.state.additionalQuestionStep > 0) {
			this.setState({ additionalQuestionStep: 0 });
		} else {
			this.props.previousStep();
		}
	}
	/*Render*/
	render () {

		const textCenter = {textAlign:'center'};
		const ville = this.state.ville;
		const infoMessage = <p>Si vous habitez actuellement &agrave; l'&eacute;tranger pr&eacute;f&eacute;rez plutot le simulateur
		<strong> <a href="https://www.service-public.fr/particuliers/vosdroits/F32823">retour en france</a> </strong>
		Des d&eacute;lais de r&eacute;sidence en france sont en effet requis pour certaines aides
		</p>;
		
		// Render additional questions step by step
		const renderAdditionalQuestions = () => {
			const { additionalQuestionStep, changementLogementRecent, difficulte, travaux, achatLogement, validationErrorsAdditional } = this.state;
			
			switch (additionalQuestionStep) {
				case 1:
					return (
						<div className="additional-question-step">
							{this.changementLogementRecent()}
							{validationErrorsAdditional.changementLogementRecent && (
								<div className="error-message">Veuillez répondre à cette question avant de continuer.</div>
							)}
							<div className="button-container">
								<button onClick={this.nextAdditionalQuestion}>Valider</button>
							</div>
						</div>
					);
				case 2:
					return (
						<div className="additional-question-step">
							{this.difficulte()}
							{validationErrorsAdditional.difficulte && (
								<div className="error-message">Veuillez répondre à cette question avant de continuer.</div>
							)}
							<div className="button-container">
								<button onClick={this.nextAdditionalQuestion}>Valider</button>
							</div>
						</div>
					);
				case 3:
					return (
						<div className="additional-question-step">
							{this.travaux()}
							{validationErrorsAdditional.travaux && (
								<div className="error-message">Veuillez répondre à cette question avant de continuer.</div>
							)}
							<div className="button-container">
								<button onClick={this.nextAdditionalQuestion}>Valider</button>
							</div>
						</div>
					);
				case 4:
					return (
						<div className="additional-question-step">
							{this.achatLogement()}
							{validationErrorsAdditional.achatLogement && (
								<div className="error-message">Veuillez répondre à cette question avant de continuer.</div>
							)}
							<div className="button-container">
								<button onClick={this.nextAdditionalQuestion}>Valider</button>
							</div>
						</div>
					);
				case 5:
					// Determine which step led to the reduction eligibility display
					const fromStep = this.state.cameFromStep === 2 ? 'difficulte' : 
									this.state.cameFromStep === 1 ? 'changementLogementRecent' : 
									this.state.cameFromStep === 3 ? 'travaux' : 'unknown';
					
					// Alternative text for difficulte step
					const alternativeText = `<strong>Voulez-vous connaître les réductions (jusqu'à 700€ / an) dont vous pouvez bénéficier sur vos factures (électricité, gaz, internet, téléphone) ?</strong>Notre partenaire papernest vous appellera directement par téléphone - 100% gratuit`;
					
					return (
						<div className="additional-question-step">
							<ReductionEligibility 
								onDataCollected={this.handleReductionEligibilityData} 
								alternativeText={alternativeText}
								fromStep={fromStep}
								ref={(ref) => this.reductionEligibilityRef = ref}
							/>
							{this.state.validationErrorsAdditional.reductionEligibility && (
								<div className="error-message">Veuillez répondre à cette question avant de continuer.</div>
							)}
							<div className="button-container">
								<button onClick={this.completeAdditionalQuestions}>Continuer</button>
							</div>
						</div>
					);
				case 6:
					// Meeting selector step - only shown when user selected 'later' for reduction eligibility
					return (
						<div className="additional-question-step">
							<MeetingSelector 
								onMeetingSelection={this.handleMeetingSelection} 
								initialValue={this.state.selectedMeeting}
								ref={(ref) => this.meetingSelectorRef = ref}
							/>
							<div className="button-container">
								<button onClick={this.completeAdditionalQuestions}>Continuer</button>
							</div>
						</div>
					);
				
				default:
					return null;
			}
		};
		
		return <div className="etape-logement step-inner-container">
			{/* Main logement form - only shown when not in additional questions mode */}
			<div style={{display: this.state.additionalQuestionStep === 0 ? 'block' : 'none'}}>
				<div className="question question-situation-logement">
					<h3 style={textCenter}>Mon Logement</h3>
					<p style={textCenter}> Si vous habitez à l’étranger : <InfoBulle message={infoMessage}/> </p>
					<select name="situation-logement"
						    className="select-situation-logement"
						    onChange={this.handleChangeSituationLogement}
						>
						<option value="" selected disabled>Sélectionnez votre situation de logement</option>
						{this.state.optionsSituationLogement.map((option)=>(
							<option value={option.value}>{option.label}</option>
						))}
					</select>
					
					{ ( this.state.situationLogement === 'locataire' )?
					<small className="textSituationLogement">figurant sur le bail ou en foyer de logement</small>
					:	''
					}
					
					{ ( this.state.situationLogement === 'heberger' )?
					<small className="textSituationLogement">chez un particulier ou en logement de fonction</small>
					:	''
					}

				</div>
				<div className="questions-logement">
				{ ( this.state.situationLogement) ?
					this.formulaireLogement()
				: ''
				}
				</div>

				<div className="question code-postal">
					<label><h3>Code Postal</h3></label>
					<input 
						type="text"
						name="code_postal"
						placeholder="Ex: 75015"
						value= {this.state.codePostal}
						onChange={this.handleChangeCodePostal}
					/>
					
					{(this.state.loadingVilles) ? <div className="loader loader-code-postal"></div> : ''}
				</div>
				{ ( this.state.optionsVille.length > 0 )?
					<div className="question selec-ville">
						<label><h3>Ville</h3></label>
						<select className="select-ville" defaultValue={ville} onChange={this.handleChangeVille}>
							
							{this.state.optionsVille.map((ville , index)=>(
								<option value={index}>{ville.nom}</option>
							)
							)}
						</select>
					</div>

				:''}
				<div className="error-container clear">
				  <FormError errors={this.state.validations.codePostal} ></FormError>
				  <FormError errors = {this.state.validationErrors}></FormError>
				</div>
				{/* Button to start additional questions */}
				{this.state.codeInsee && (
					<button className="btn-validation" onClick={this.startAdditionalQuestions}> Valider </button>
				)}
				<div className="button-container previous">
					<button onClick={this.restart}> Recommencer </button>
				</div>
			</div>
			
			{/* Additional questions displayed step by step - only shown when in additional questions mode */}
			<div style={{display: this.state.additionalQuestionStep > 0 ? 'block' : 'none'}}>
				{renderAdditionalQuestions()}
			</div>
		</div>;
	}
}

export default Logement;
